import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { CommonService } from 'src/app/services';
import { SharedserviceService } from 'src/app/services/sharedservice.service';

import { WindowRefService } from './../../services/window-ref.service';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Component, OnInit, NgZone, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Location } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss'],
  providers: [WindowRefService, DatePipe, NgxUiLoaderService]
})
export class DetailComponent implements OnInit {
  imagepathstatic = environment.imageurl;
  currentdate: any = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
  endatdate: any = new Date((new Date().getTime() - 86400)); ChargeAmount: any = 0;
  buttontext: any; Citydata: any = {}; Booking_token: any;
  search_details: any;
  flightdetails: any;
  searched_flight_detail: any;
  imagesrc: any;
  return_d_date: any;
  rreturn_d_date: any;
  userdata: any;
  public options: any;
  public myFilter: any;
  // chechout process
  public bookTicketForm: FormGroup;
  myArr = [];
  myArr1 = [];
  uploadData: any;
  error: boolean = false;
  private order_id; any;
  private _window: any;
  public traingDetail: any;
  public submitted: Boolean
  private sub: any;
  private categoryId: number;
  public transcationID: any;
  public TicketbookForm: FormGroup
  user_id: string;
  public flag: any = 1;
  public price: number = 0;
  public totalPrice: number = 0;
  public rzp: any;
  public UidUploadResponse: Array<any> = []; travlerDtl: any;
  dobDate: any;
  valueDate: any;
  processingPayment: boolean;
  paymentResponse: any = {};
  no_of_traveller: any;
  form_data: any;
  booking_id: any;
  reference_id: any;
  shared_inventory_id: any;
  paytm_order_id: any;
  adultcounter: number = 0;
  childcounter: number = 0;
  infantcounter: number = 0;
  infoData: any;
  inv_user_type: any;
  signature: any;
  confirmpopupdata: any;
  confirmpopupdataData: any;
  txnToken: any;
  paytmpaymentapiurl: any;
  dataStore: any;
  paytmmid: any;
  specialInfo: any;
  urlsuccess: any;
  urlunsuccess: any;
  calcPmtCharg: any;
  chargeTotal: any;
  agecal: any
  constructor(private datePipe: DatePipe, private activatedRoute: ActivatedRoute, private fb: FormBuilder, public dataservice: CommonService, public httpClient: SharedserviceService, public router: Router, private toastr: ToastrManager, private location: Location, private changeRef: ChangeDetectorRef, private zone: NgZone, private winRef: WindowRefService, private formBuilder: FormBuilder, private sanitizer: DomSanitizer, private ngxLoader: NgxUiLoaderService,) {
    this.flightdetails = JSON.parse(sessionStorage.getItem("searchedflights_detail"))
    this.Booking_token = JSON.parse(sessionStorage.getItem("Booking_token"))
    this.Citydata = JSON.parse(sessionStorage.getItem("offerDetail"))

    //console.log("ssssssssss",this.flightdetails);
    // this.dataservice=this.baseUrlPartner


    this.imagesrc = JSON.parse(sessionStorage.getItem("imagepath"))
    this.travlerDtl = JSON.parse(sessionStorage.getItem("travlerDetail"))
    this.userdata = JSON.parse(localStorage.getItem("userAgency_dealfare"));
    this._window = winRef.nativeWindow;
    if(this.userdata){
      this.form_data = JSON.parse(sessionStorage.getItem("search_form"));
    }else{
      this.form_data = JSON.parse(sessionStorage.getItem("search_form_Data"));
    }

    // this.form_data=JSON.parse(sessionStorage.getItem("search_form"));
    if (localStorage.getItem("traveller_by_inventory")) {
      this.no_of_traveller = localStorage.getItem("traveller_by_inventory")

    } else {
      this.no_of_traveller = (this.form_data.adult + this.form_data.child + this.form_data.infant);
      // this.no_of_traveller = this.travlerDtl.adult;
    }
    this.ngxLoader.start();
    this.searched_flight_detail = this.flightdetails;
    this.ngxLoader.stop();
    if (this.dataservice.searchedflightticketusertype)
      this.inv_user_type = this.dataservice.searchedflightticketusertype;
  }

  foo(): void {

    //console.log(location.origin);
    this.urlsuccess = location.origin + '/home/success/';
    //  this.urlsuccess = 'https://fareboutique.tech/gofare/home/success/';
    //console.log("actual Url ==========",this.urlsuccess);
    this.urlunsuccess = location.origin + '/home/unsuccess';
    //  this.urlunsuccess = 'https://fareboutique.tech/gofare/home/unsuccess';
  }

  getSantizeUrl(url, img) {
    var url1 = url.replace('"', '');
    return this.sanitizer.bypassSecurityTrustUrl(url1.replace('"', '') + "/" + img);
  }

  ngAfterViewChecked() {
    //your code to update the model
    this.changeRef.detectChanges();
  }

  timeConvert(n) {
    var num = n;
    var hours = (num / 60);
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    return rhours + " hr  " + rminutes + " min";
  }

  //  durationdiff(list, type) {
  //   var dep_time = this.flightdetails.departure_time
  //   var arr_time = this.flightdetails.arrival_time
  //   var dep_date = this.flightdetails.departure_date
  //   // console.log("dep_time are ::::========>>>>>>>",list);
  //   // console.log("dep_time are :",dep_time,"arr_time are :",arr_time,"dep_date are :",dep_date);
  //   var dep_hr = parseInt(dep_time.split(':')[0]);
  //   var arr_hr = parseInt(arr_time.split(':')[0]);
  //   //console.log("hr :: ",dep_hr,arr_hr);
  //   if (arr_hr < dep_hr) {
  //     var nwdate;
  //     if (!dep_date) {
  //       nwdate = new Date();
  //     } else {
  //       nwdate = new Date(dep_date);
  //     }
  //     //console.log("now date ::: ",nwdate)
  //     var newdate = nwdate.setDate(nwdate.getDate() + 1);
  //     if (type == 'oneway') {
  //       this.return_d_date = this.datePipe.transform(newdate, 'yyyy-MM-dd');
  //     } else {
  //       this.rreturn_d_date = this.datePipe.transform(newdate, 'yyyy-MM-dd');
  //     }
  //   } else {
  //     this.return_d_date = dep_date;
  //     this.rreturn_d_date = dep_date;
  //   }
  //   //console.log("hr :: ",this.return_d_date); 
  //   var start_date = dep_date + " " + dep_time;
  //   var end_date = this.return_d_date + " " + arr_time;
  //   //console.log("start date : ",start_date,"end date :: ",end_date);
  //   return this.getDataDiff(new Date(start_date.toString()), new Date(end_date.toString()));
  // }
  durationdiff(list,type){
    // console.log("check type list====656====",list, "type check====2====", type);
    
    var dep_time = list.departure_time;  var arr_time = list.arrival_time;
    var dep_date = list.departure_date;     var start_date:any;  var end_date:any;
    var dep_hr=parseInt(dep_time.split(':')[0]);  var arr_hr=parseInt(arr_time.split(':')[0]);
    if (type == 'oneway'){
      // console.log("oneway difference",list.duration,typeof(list.duration))
      if(list.duration == "0"){
        // console.log("duration zero")
        if (arr_hr < dep_hr) {
          var nwdate;
          if (!dep_date) {  nwdate = new Date();  } 
          else {  nwdate = new Date(dep_date);  }
          var newdate = nwdate.setDate(nwdate.getDate() + 1);
          this.return_d_date = this.datePipe.transform(newdate, 'yyyy-MM-dd');
        } 
        else {  this.return_d_date = dep_date;  }
        start_date=dep_date+" "+dep_time;  end_date=this.return_d_date+" "+arr_time;
        return this.getDataDiff(new Date(start_date.toString()), new Date(end_date.toString()));
      }else{
        if(list.next_day == 1){
          // console.log("duration not zero and nextday 1")
          if (!dep_date) {  nwdate = new Date();  } 
          else {  nwdate = new Date(dep_date);  }
          var newdate = nwdate.setDate(nwdate.getDate() + 1);
          this.return_d_date = this.datePipe.transform(newdate, 'yyyy-MM-dd');
        }else{
          // console.log("duration not zero and nextday 0")
          this.return_d_date = list.departure_date;
          start_date=dep_date+" "+dep_time;  end_date=this.return_d_date+" "+arr_time;
          return this.getDataDiff(new Date(start_date.toString()), new Date(end_date.toString()));
        }
        return parseInt((list.duration).split(':')[0])+' hr : '+parseInt((list.duration).split(':')[1])+' mins';
      }
    }else{
        if(list.return_flight_data.duration == "0"){
          if (arr_hr < dep_hr) {
            var nwdate;
            if (!dep_date) {  nwdate = new Date();  } 
            else {  nwdate = new Date(dep_date);  }
            var newdate = nwdate.setDate(nwdate.getDate() + 1);
            this.rreturn_d_date = this.datePipe.transform(newdate, 'yyyy-MM-dd');
          } 
          else {  this.rreturn_d_date = dep_date;  }
          start_date=dep_date+" "+dep_time;  end_date=this.return_d_date+" "+arr_time;
          return this.getDataDiff(new Date(start_date.toString()), new Date(end_date.toString()));
        }
        else{
          if(list.return_flight_data.next_day == 1){
            // console.log("duration not zero and nextday 1")
            if (!dep_date) {  nwdate = new Date();  } 
            else {  nwdate = new Date(dep_date);  }
            var newdate = nwdate.setDate(nwdate.getDate() + 1);
            this.rreturn_d_date = this.datePipe.transform(newdate, 'yyyy-MM-dd');
          }else{
            // console.log("duration not zero and nextday 0")
            this.rreturn_d_date = list.return_flight_data.return_departure_date;
          }
          return parseInt((list.return_flight_data.duration).split(':')[0])+' hr : '+parseInt((list.return_flight_data.duration).split(':')[1])+' mins';
      }
    }  
  
  }
  
  durationSplit(duration) {

    var split_duration = duration.split(':');
    return split_duration[0] + ' hrs : ' + split_duration[1] + ' mins'

  }

  getDataDiff(s_date, e_date) {
    var diff = e_date.getTime() - s_date.getTime();
    var days = Math.floor(diff / (60 * 60 * 24 * 1000));
    var hours = Math.floor(diff / (60 * 60 * 1000)) - (days * 24);
    var minutes = Math.floor(diff / (60 * 1000)) - ((days * 24 * 60) + (hours * 60));
    var seconds = Math.floor(diff / 1000) - ((days * 24 * 60 * 60) + (hours * 60 * 60) + (minutes * 60));
    return hours + " hrs " + ": " + minutes + " min";
    // return { day: days, hour: hours, minute: minutes, second: seconds };
  }

  // convenience getters for easy access to form fields
  get f() { return this.bookTicketForm.controls; }
  get t() { return this.f.Attendie as FormArray; }

  onChangeTickets(e) {
    const numberOfAttendie = e || 1;

    if (this.t.length < numberOfAttendie) {

      for (let i = this.t.length; i < numberOfAttendie; i++) {
        //alert(i)
        this.totalPrice = this.price * (i + 1);
        if (i < this.form_data.infant) {
          this.agecal = 1
        }
        else if (i >= this.form_data.infant && i < this.form_data.infant + this.form_data.child) {
          this.agecal = 5
        }
        else {
          this.agecal = 20
        }

        //console.log("AgeCalulation::::::::::::", this.agecal);  
        // alert(this.totalPrice)
        if (this.flightdetails.international_flight_staus == 1) {
          this.t.push(this.formBuilder.group({
            gender: ['', Validators.required],
            first_name: ['', Validators.required],
            middle_name: [''],
            last_name: ['', Validators.required],

            // age: ['', [Validators.required]],
            age: [this.agecal, [Validators.required]],

            passport_no: ['', [Validators.required]],
            passport_expire_date: ['', [Validators.required]],
            dob: ['', [Validators.required]]
          }));
        } else {
          this.t.push(this.formBuilder.group({
            gender: ['', Validators.required],
            first_name: ['', Validators.required],
            middle_name: [''],
            last_name: ['', Validators.required],
            age: [this.agecal, [Validators.required]],
            passport_no: [''],
            passport_expire_date: [''],
            dob: this.agecal == 1 ? ['', [Validators.required]] : ['']
            // dob: ['']
          }));
        }

      }
    } else {
      for (let i = this.t.length; i >= numberOfAttendie; i--) {
        // alert(i)
        this.t.removeAt(i);
        // alert(i)
        if (i > numberOfAttendie)
          this.totalPrice -= this.price;
        // this.t.clear()
      }
    }
  }

  convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }






  // confirmBook(travller) {
  //   var self = this;
  //   this.submitted = true;
  //   console.log("this.sadasdsadasd",this.bookTicketForm)
  //   // stop here if form is invalid
  //   if (this.bookTicketForm.valid) {
  //     $('#bookingConfirm').modal('show');
  //     console.log("travller check value:::::::::::::", travller);
  //     this.confirmpopupdata = travller;      
  //   }else{
  //     return;
  //   }

  // }

  confirmBook(travller) {
    this.submitted = true;
    console.log("flight :::>>>>", travller)
    if (this.bookTicketForm.valid) {
      $('#bookingConfirm').modal('show');
      console.log("travller check value:::::::::::::", travller);
      this.confirmpopupdata = travller;
    }
    else {
      return
    }
  }

  onSubmit_new(vender_status) {
    console.log('onSubmit_new ==================================== called');
    
    var PG_request: any = {}
    sessionStorage.removeItem('front_booking_data'); sessionStorage.removeItem('booking_data');
    sessionStorage.removeItem('booking_data_agency'); sessionStorage.removeItem("inventory_from");
    var self = this; this.submitted = true;
    if (this.bookTicketForm.valid) {
      this.ngxLoader.start();
      var data = this.bookTicketForm.value;
      var tax_amount = 0;
      var amount;
      var t_amount;
      data.Attendie.forEach(element => {
        if (element.dob != '') {
          element.dob = this.convert(element.dob)
        }
      });
      var send_requestdata1; var flightBooking1;
      if (vender_status == 2 && (this.flightdetails.payment_gatway_charges == 1 || this.flightdetails.payment_gatway_charges == 0)) {
        amount = this.flightdetails.total_payable_price;
        t_amount = Number(amount) + Number(tax_amount);
      } else {
        amount = this.flightdetails.total_payable_price;
        t_amount = Number(amount) + Number(tax_amount);
      }
      data.Attendie.forEach(element => {
        element.ticket_price = Number(element.ticket_price)
      });
      if (this.flightdetails.international_flight_staus == 1) {
        data.Attendie.forEach(element => {
          element.dob = this.convert(element.dob);
          element.passport_expire_date = this.convert(element.passport_expire_date)
        });
      }
      var bookBothSide 
      if(this.userdata){
        bookBothSide = false;
      }else{
        bookBothSide = true;
      }
      send_requestdata1 = {
        flight_id: Number(this.flightdetails.flight_id), 
        departure_date: this.flightdetails.departure_date, 
        return_date: this.form_data.return_date,
        adult: Number(this.form_data.adult) != 0 ? Number(this.form_data.adult) : 1,
        children: Number(this.form_data.child) == 0 ? 0 : Number(this.form_data.child),
        infant: Number(this.form_data.infant) == 0 ? 0 : Number(this.form_data.infant),
        total_book_seats: Number(this.form_data.adult) + Number(this.form_data.child) + Number(this.form_data.infant),
        contact_name: data.contact_name, contact_email: data.contact_email, 
        contact_number: data.contact_number,
        dep_city_code: this.Citydata.depcode, 
        arr_city_code: this.Citydata.arrcode,
        transaction_id: '', 
        payment_success_url: this.urlsuccess, 
        payment_failure_url: this.urlunsuccess,
        special_Information: this.specialInfo,
        flight_traveller_details: data.Attendie, 
        inventory_from: this.flightdetails.pricing.inventory_from,
        booking_token_id: this.Booking_token, 
        total_amount: this.flightdetails.pricing.final_pay_amount,
        outside:bookBothSide
      }
      console.log("check request data===============514==========()===",send_requestdata1);
      
      flightBooking1 = `v1/common_new/book/${this.flightdetails.pricing.inventory_from}`
      if (this.userdata) {
        if (this.ChargeAmount == 0) {
          this.ngxLoader.stop();
          if (this.flightdetails.pricing.final_pay_amount <= this.userdata.available_balance) {
            this.Commonbook(flightBooking1, send_requestdata1)
          } else {
            sessionStorage.setItem("inventory_from", JSON.stringify(this.flightdetails.pricing.inventory_from))
            sessionStorage.setItem("flight_booking_request", JSON.stringify(send_requestdata1))
            PG_request = {
              name: data.contact_name, email: data.contact_email, mobile: data.contact_number,
              amount: (this.flightdetails.pricing.final_pay_amount - (this.userdata.available_balance ? this.userdata.available_balance : 0)),
              // amount: (this.flightdetails.pricing.final_pay_amount-(this.userdata.available_balance?this.userdata.available_balance:0)).toString(), 
              payment_success_url: this.urlsuccess, payment_failure_url: this.urlunsuccess
            }
            this.AddBalance(PG_request)
          }

        } else {
          this.ngxLoader.stop();
          if (this.flightdetails.ChargeAmount <= this.userdata.available_balance) {
            this.Commonbook(flightBooking1, send_requestdata1)
          } else {
            sessionStorage.setItem("inventory_from", JSON.stringify(this.flightdetails.pricing.inventory_from))
            sessionStorage.setItem("flight_booking_request", JSON.stringify(send_requestdata1))
            PG_request = {
              name: data.contact_name, email: data.contact_email, mobile: data.contact_number,
              amount: this.ChargeAmount, payment_success_url: this.urlsuccess, payment_failure_url: this.urlunsuccess
            }
            this.AddBalance(PG_request)
          }
          this.ngxLoader.stop();
        }
      } else {
        sessionStorage.setItem("inventory_from", JSON.stringify(this.flightdetails.pricing.inventory_from))
        sessionStorage.setItem("flight_booking_request", JSON.stringify(send_requestdata1))
        PG_request = {
          name: data.contact_name, email: data.contact_email, mobile: data.contact_number,
          amount: this.flightdetails.pricing.final_pay_amount, payment_success_url: this.urlsuccess, payment_failure_url: this.urlunsuccess
        }
        this.AddBalance(PG_request)
      }

    }
  }

  AddBalance(data){
    // data.amount=(data.amount).toString()
    let self=this;
    this.httpClient.postRequest('v1/wallet/add_balance', data).subscribe((res: any) => {
      self.httpClient.loadingShow = false;
      if (res.replyCode == "success") {

        if (!(this.userdata)) {
          localStorage.setItem("tokenAgency_dealfare", JSON.stringify(res.auth_token));
        }
        sessionStorage.setItem("add_balance_bool",JSON.stringify(true))
        this.ngxLoader.stop();
        console.log("add balance response ::::::::::>>>>>>>>>",res)
        if(res.pg_type == 'paytm'){
          // console.log('it is paytm =============================');
          // return;
          sessionStorage.setItem('pg_type',JSON.stringify('paytm'))
          if (res.data.paytm_order_id != '') {
              this.booking_id = res.data.flight_booking_id; 
              this.reference_id = res.data.reference_id; 
              this.shared_inventory_id = res.data.shared_inventory_id; 
              this.paytm_order_id = res.data.paytm_order_id
              // localStorage.removeItem("traveller_by_inventory");  
              this.dataStore = res.data;
              var bookingdata_Store = { 
                booking_id: this.dataStore.flight_booking_id, 
                reference_id: this.dataStore.reference_id,  
                shared_inventory_id: this.dataStore.shared_inventory_id, 
                paytm_order_id: this.dataStore.paytm_order_id 
              }
              sessionStorage.setItem("front_booking_data", JSON.stringify(bookingdata_Store))

              /******SessionStore******/
              localStorage.removeItem("traveller_by_inventory");  
              self.booking_id = res.data.flight_booking_id; 
              self.reference_id = res.data.reference_id;
              this.shared_inventory_id = res.data.shared_inventory_id;  
              this.signature = res.data.signature;  
              this.txnToken = res.data.txnToken
              this.paytmpaymentapiurl = res.data.PAYTMPAYMENTAPIURL; 
              this.paytmmid = res.data.PAYTMMID
              this.options = { 
                mid: this.paytmmid,  
                orderId: this.paytm_order_id, 
                txnToken: this.txnToken 
              };
              const my_form: any = document.createElement('form'); 
              my_form.name = 'paytm_form'; 
              my_form.method = 'post'; 
              my_form.action = this.paytmpaymentapiurl + "mid=" + this.paytmmid + "&orderId=" + this.paytm_order_id;
              const myParams = Object.keys(this.options);
              for (let i = 0; i < myParams.length; i++) {
                const key = myParams[i];
                let my_tb: any = document.createElement('input'); 
                my_tb.type = 'hidden';
                my_tb.name = key; 
                my_tb.value = this.options[key]; 
                my_form.appendChild(my_tb);
              };
              document.body.appendChild(my_form); 
              my_form.submit();
            }
        }else{
          localStorage.removeItem("traveller_by_inventory"); 
          sessionStorage.setItem('pg_type',JSON.stringify('easebuzz'))
          sessionStorage.setItem('easebuzz_token',JSON.stringify(res.token))
          console.log('res.data ============================== 545 ===', res.data);
          
          // return;
          window.open(res.data,"_self")

        }
      }
      if(res.replyCode == 'success' || res.replyCode == 'error'){ this.ngxLoader.stop(); }
    }, error => {  this.toastr.errorToastr(error.error.replyMsg, "Error");  });
  }

  NormalBook(url, data) {
    var self = this;
    this.httpClient.postRequest(url, data).subscribe((res: any) => {
      self.httpClient.loadingShow = false;
      if (res.replyCode == "success") {
        sessionStorage.setItem("add_balance_bool", JSON.stringify(false))
        this.ngxLoader.stop();
        this.dataStore = res.data;
        var bookingdata = {
          booking_id: this.dataStore.flight_booking_id, reference_id: this.dataStore.reference_id,
          shared_inventory_id: this.dataStore.shared_inventory_id, paytm_order_id: this.dataStore.paytm_order_id
        }
        sessionStorage.setItem("booking_data_agency", JSON.stringify(bookingdata)); self.submitted = false;
        self.bookTicketForm.reset(); self.myArr = []; self.myArr1 = []; sessionStorage.removeItem("search_form");
        sessionStorage.removeItem("imagepath"); sessionStorage.removeItem("flights"); sessionStorage.removeItem("searchedflights_detail");
        sessionStorage.removeItem("form_data"); localStorage.removeItem("inventory_flight_id"); localStorage.removeItem("inventory_d_date");
        localStorage.removeItem("traveller_by_inventory"); localStorage.removeItem("inventory_data"); self.dataservice.reloadbalance();
        self.router.navigateByUrl("/home/success");
      }
      if (res.replyCode == 'success' || res.replyCode == 'error') { this.ngxLoader.stop(); }
    }, error => { this.toastr.errorToastr(error.error.replyMsg, "Error"); `` });
  }

  Commonbook(url, data) {
    var self = this; data.pg = false;
    this.httpClient.postRequest(url, data).subscribe((res: any) => {
      self.httpClient.loadingShow = false;
      if (res.replyCode == "success") {
        sessionStorage.setItem("add_balance_bool", JSON.stringify(false))
        this.ngxLoader.stop();
        console.log("resdata", res.data)
        this.booking_id = res.data.flight_booking_id; this.reference_id = res.data.reference_id; this.shared_inventory_id = res.data.shared_inventory_id;
        var bookingdata = { booking_id: this.booking_id, transaction_id: "vender", reference_id: this.reference_id, shared_inventory_id: this.shared_inventory_id }
        sessionStorage.setItem("booking_data_agency", JSON.stringify(bookingdata)); localStorage.removeItem("traveller_by_inventory");
        self.booking_id = res.data.flight_booking_id; self.reference_id = res.data.reference_id; sessionStorage.removeItem("search_form");
        sessionStorage.removeItem("imagepath"); sessionStorage.removeItem("flights"); sessionStorage.removeItem("searchedflights_detail");
        sessionStorage.removeItem("form_data"); localStorage.removeItem("inventory_flight_id"); localStorage.removeItem("inventory_d_date");
        localStorage.removeItem("inventory_data"); localStorage.removeItem("companyname"); self.bookTicketForm.reset(); self.router.navigateByUrl("/home/success");
      } else {
        this.ngxLoader.stop();
        localStorage.removeItem("traveller_by_inventory"); self.booking_id = res.data.flight_booking_id; self.reference_id = res.data.reference_id;
        sessionStorage.removeItem("search_form"); sessionStorage.removeItem("imagepath"); sessionStorage.removeItem("flights");
        sessionStorage.removeItem("searchedflights_detail"); sessionStorage.removeItem("form_data"); localStorage.removeItem("inventory_flight_id");
        localStorage.removeItem("inventory_d_date"); localStorage.removeItem("inventory_data"); localStorage.removeItem("companyname"); self.bookTicketForm.reset();
        self.router.navigateByUrl("/offerin");
      }
    }, error => {
      this.ngxLoader.stop();
      sessionStorage.removeItem("search_form"); sessionStorage.removeItem("imagepath"); sessionStorage.removeItem("flights");
      sessionStorage.removeItem("searchedflights_detail"); sessionStorage.removeItem("form_data"); localStorage.removeItem("inventory_flight_id");
      localStorage.removeItem("inventory_d_date"); localStorage.removeItem("inventory_data"); self.bookTicketForm.reset();
      self.router.navigateByUrl("/home/unsuccess"); this.toastr.errorToastr(error.error.replyMsg, "Error");
    });
  }

  // onSubmit(vender_status) {
  //   var self = this;
  //   this.submitted = true;
  //   // stop here if form is invalid
  //   if (this.bookTicketForm.valid) {
  //     var data = this.bookTicketForm.value; 
  //     // var data = this.flightdetails.
  //     var tax_amount = 0; 
  //     var amount; 
  //     var t_amount; 
  //     var new_value; 
  //     var totalamount;
  //     // if (this.flightdetails.payment_gatway_charges == 1 && this.chargeTotal > this.searched_flight_detail.vendorAmountLimit) {

  //     //   amount = this.flightdetails.final_pay_amount ;
  //     //   totalamount = this.flightdetails.final_pay_amount

  //     //   // totalamount = this.flightdetails.priciing.final_pay_amount + Number((this.flightdetails.priciing.final_pay_amount * Number(this.flightdetails.percentage)) / 100) + Number(this.flightdetails.amount)
  //     //   // t_amount = Number(totalamount) + Number(tax_amount);
  //     // } else {

  //     //   amount = this.flightdetails.final_pay_amount ;
  //     //   totalamount = this.flightdetails.final_pay_amount
  //     //   // t_amount = Number(totalamount) + Number(tax_amount);
  //     // }

  //     if (this.flightdetails.international_flight_staus == 1) {
  //       data.Attendie.forEach(element => {
  //         element.dob = this.convert(element.dob)
  //         element.passport_expire_date = this.convert(element.passport_expire_date)
  //       });
  //     }else{
  //       data.Attendie.forEach(element => {
  //         // console.log("dob check value::::::::::::",element.dob);
  //           if(element.dob != null && element.dob != ""){  
  //             element.dob=this.convert(element.dob)  
  //           }else{element.dob=""}
  //       });
  //     }
  //     var inventoryFrom = this.flightdetails.pricing.inventory_from;
  //     var send_requestdata = {
  //       // user_id: this.flightdetails.flight_user_id,
  //       // flight_id: this.flightdetails.flight_id,
  //       // plan_id: this.flightdetails.flight_plan,
  //       // departure_date: this.flightdetails.departure_date,
  //       // return_date: this.form_data.return_date,
  //       // booking_token_id: JSON.parse(sessionStorage.getItem("Booking_token")),
  //       // adult: this.form_data.adult,
  //       // children: this.form_data.child,
  //       // infant: this.form_data.infant,
  //       // total_book_seats: this.form_data.adult + this.form_data.child + this.form_data.infant,
  //       // tax_amount: tax_amount.toString(),
  //       // amount: this.flightdetails.pricing.final_pay_amount,
  //       // total_amount: this.flightdetails.pricing.final_pay_amount,
  //       // contact_name: data.contact_name,
  //       // contact_email: data.contact_email,
  //       // contact_number: data.contact_number,
  //       // status: '1',
  //       // transaction_id: '',
  //       // special_Information: this.flightdetails.special_Information,
  //       // flight_traveller_details: data.Attendie,
  //       // share_by_user_id: this.flightdetails.share_by_user_id,
  //       // share_to_user_id: this.flightdetails.share_to_user_id,
  //       // vendor_own_flight: this.flightdetails.vendor_flight,
  //       // payment_success_url: this.urlsuccess,
  //       // payment_failure_url: this.urlunsuccess

  //       flight_id: this.flightdetails.flight_id,
  //       adult: this.form_data.adult,
  //       children: this.form_data.child,
  //       infant: this.form_data.infant,
  //       total_book_seats: this.form_data.adult + this.form_data.child + this.form_data.infant,
  //       total_amount: this.flightdetails.pricing.final_pay_amount,
  //       // amount: this.flightdetails.pricing.final_pay_amount,
  //       payment_success_url: this.urlsuccess,
  //       payment_failure_url: this.urlunsuccess,
  //       contact_name: data.contact_name,
  //       contact_email: data.contact_email,
  //       contact_number: data.contact_number,
  //       dep_city_code:this.flightdetails.departure_airport_code,
  //       arr_city_code:this.flightdetails.arrival_airport_code,
  //       departure_date:this.flightdetails.departure_date,
  //       booking_token_id:JSON.parse(sessionStorage.getItem("Booking_token")),
  //       inventory_from:inventoryFrom,
  //       flight_traveller_details: data.Attendie,
  //     }

  //     /*if(vender_status != 1 ){*/
  //     for (let index = 0; index < data.Attendie.length; index++) {
  //       const element = data.Attendie[index];
  //       if (element.age <= 2) {
  //         this.infantcounter += 1;
  //       }
  //       else if (element.age > 2 && element.age <= 12) {
  //         this.childcounter += 1;
  //       }
  //       else {
  //         this.adultcounter += 1;
  //       }
  //     }

  //     /* } */
  //     //console.log("Adult,Children,Infant:::::::::::",send_requestdata.adult,send_requestdata.children,send_requestdata.infant);
  //     //  return false;
  //     /* if(vender_status == 1 ){

  //     //console.log("flight book detail",send_requestdata);
  //       this.httpClient.postRequest('v1/flight_booking', send_requestdata).subscribe((res: any) => {
  //       //  this.httpClient.postRequest('v1/flight_booking',send_requestdata).subscribe((res)=> {
  //       self.httpClient.loadingShow = false;
  //           if(res.replyCode == "success") {
  //           this.booking_id=res.data.flight_booking_id
  //           this.reference_id=res.data.reference_id
  //           this.shared_inventory_id=res.data.shared_inventory_id
  //           var bookingdata={
  //             booking_id: this.booking_id, 
  //             // transaction_id: "vender",
  //             reference_id: this.reference_id,
  //             shared_inventory_id: this.shared_inventory_id
  //           }
  //           sessionStorage.setItem("booking_data_agency",JSON.stringify(bookingdata))
  //             localStorage.removeItem("traveller_by_inventory");
  //             self.booking_id=res.data.flight_booking_id; 
  //             self.reference_id=res.data.reference_id; 
  //               sessionStorage.removeItem("search_form");
  //               sessionStorage.removeItem("imagepath");
  //               sessionStorage.removeItem("flights");
  //               sessionStorage.removeItem("searchedflights_detail");
  //               sessionStorage.removeItem("form_data");
  //               localStorage.removeItem("inventory_flight_id");
  //               localStorage.removeItem("inventory_d_date");
  //               localStorage.removeItem("inventory_data");
  //               self.bookTicketForm.reset();
  //               self.router.navigateByUrl("/home/success");                
  //             }
  //           },error => {
  //           this.toastr.errorToastr(error.error.replyMsg,"Error");
  //           });
  //       }else{*/
  //     /*if(this.flightdetails.creditlmitAmount>= t_amount){*/
  //     //
  //     //console.log("hemantchange",this.flightdetails);
  //     // if(this.validate_adult_child_infant(this.adultcounter,this.childcounter,this.infantcounter,this.form_data.adult,this.form_data.child,this.form_data.infant)){

  //     // this.httpClient.postRequest('v1/flight_booking', send_requestdata).subscribe((res: any) => {
  //       console.log("booking request data:::::553======",send_requestdata);
  //     this.httpClient.postRequest('v1/common_new/book/'+inventoryFrom, send_requestdata).subscribe((res: any) => {
  //       console.log("booking request data:::::555======",send_requestdata);
  //       self.httpClient.loadingShow = false;
  //       if (res.replyCode == "success") {
  //         if (res.data.paytm_order_id != '') {
  //           // this.toastr.errorToastr("Balance amount is low kindly please contact us on 9887444234","Error");
  //           // return false;
  //           this.booking_id = res.data.flight_booking_id
  //           this.reference_id = res.data.reference_id
  //           this.shared_inventory_id = res.data.shared_inventory_id
  //           this.paytm_order_id = res.data.paytm_order_id
  //           localStorage.removeItem("traveller_by_inventory");
  //           // if(vender_status == 2){
  //           /******SessionStore******/
  //           // return false;
  //           this.dataStore = res.data;
  //           //console.log("LocalStore======",this.dataStore);
  //           var bookingdata_Store = {
  //             booking_id: this.dataStore.flight_booking_id,
  //             reference_id: this.dataStore.reference_id,
  //             shared_inventory_id: this.dataStore.shared_inventory_id,
  //             paytm_order_id: this.dataStore.paytm_order_id
  //           }

  //           //console.log("LocalStore",bookingdata_Store);

  //           sessionStorage.setItem("front_booking_data", JSON.stringify(bookingdata_Store))

  //           /******SessionStore******/
  //           localStorage.removeItem("traveller_by_inventory");
  //           self.booking_id = res.data.flight_booking_id;
  //           self.reference_id = res.data.reference_id;
  //           this.shared_inventory_id = res.data.shared_inventory_id

  //           this.signature = res.data.signature
  //           this.txnToken = res.data.txnToken
  //           this.paytmpaymentapiurl = res.data.PAYTMPAYMENTAPIURL
  //           this.paytmmid = res.data.PAYTMMID

  //           this.options = {
  //             mid: this.paytmmid,
  //             orderId: this.paytm_order_id,
  //             txnToken: this.txnToken
  //           };
  //           const my_form: any = document.createElement('form');
  //           my_form.name = 'paytm_form';
  //           my_form.method = 'post';
  //           my_form.action = this.paytmpaymentapiurl + "mid=" + this.paytmmid + "&orderId=" + this.paytm_order_id;

  //           const myParams = Object.keys(this.options);
  //           for (let i = 0; i < myParams.length; i++) {
  //             const key = myParams[i];
  //             let my_tb: any = document.createElement('input');
  //             my_tb.type = 'hidden';
  //             my_tb.name = key;
  //             my_tb.value = this.options[key];
  //             my_form.appendChild(my_tb);
  //           };


  //           document.body.appendChild(my_form);
  //           // return false;
  //           my_form.submit();

  //         }
  //         else {

  //           this.dataStore = res.data;
  //           var bookingdata = {
  //             booking_id: this.dataStore.flight_booking_id,
  //             reference_id: this.dataStore.reference_id,
  //             shared_inventory_id: this.dataStore.shared_inventory_id,
  //             paytm_order_id: this.dataStore.paytm_order_id
  //           }
  //           sessionStorage.setItem("booking_data_agency", JSON.stringify(bookingdata))
  //           // alert()
  //           // document.getElementById("openModalButton").click();            
  //           self.submitted = false;
  //           // self.TicketbookForm.reset();
  //           self.bookTicketForm.reset();
  //           //self.location.back();
  //           self.myArr = []
  //           self.myArr1 = []
  //           sessionStorage.removeItem("search_form");
  //           sessionStorage.removeItem("imagepath");
  //           sessionStorage.removeItem("flights");
  //           sessionStorage.removeItem("searchedflights_detail");
  //           sessionStorage.removeItem("form_data");
  //           localStorage.removeItem("inventory_flight_id");
  //           localStorage.removeItem("inventory_d_date");
  //           localStorage.removeItem("traveller_by_inventory");
  //           localStorage.removeItem("inventory_data");
  //           self.dataservice.reloadbalance();
  //           self.router.navigateByUrl("/home/success");
  //         }
  //       }
  //     }, error => {
  //       this.toastr.errorToastr(error.error.replyMsg, "Error");
  //       //
  //       //console.log('sunilerrrrrrr');
  //     });
  //     // }
  //     /*}
  //     else{
  //       this.buttontext="Creadit Limit not sufficient";
  //       this.toastr.errorToastr('Creadit Limit not sufficient','Error')

  //     }*/
  //     /* }*/



  //   }
  // }

  special_info() {
    this.httpClient.get("v1/users/get_website_owner_data").subscribe((res) => {
      if (res.replyCode == 'success') {
        this.specialInfo = res.special_info;
        // console.log("check special info data::::::868:::::",this.specialInfo);        
        // this.ngxLoader.stop();
      } else {
        // this.ngxLoader.stop();
        this.toastr.errorToastr(res.replyMsg, 'Error');
      }
    }, err => {
      // this.ngxLoader.stop();
      this.toastr.errorToastr(err['error']['message'], 'Error');
    });

  }


  validate_adult_child_infant(a1, b1, c1, a2, b2, c2) {
    if (this.flightdetails.international_flight_staus == 0) {
      if ((a1 == a2) && (b1 == b2) && (c1 == c2)) {
        return true;
      } else {
        this.toastr.errorToastr('Number of Adult,Child and Infant are not correct.', "Passanger Details are not correct.")
        return false;
      }
    } else {
      return true;
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
  ngOnInit(): void {
    this.dataservice.reloadbalance();
    this.foo();
    if (this.userdata) {
      this.bookTicketForm = this.formBuilder.group({
        contact_name: [this.userdata.name, Validators.required],
        contact_email: [this.userdata.email, Validators.required],
        contact_number: [this.userdata.mobile, Validators.required],
        //  special_Information: [''],
        //  special_Information: [this.userdata.special_Information],
        Attendie: new FormArray([])
      });
    }
    else {
      this.bookTicketForm = this.formBuilder.group({
        contact_name: ['', Validators.required],
        contact_email: ['', Validators.required],
        contact_number: ['', Validators.required],
        //  special_Information: [''],
        // special_Information: [this.userdata.special_Information],

        Attendie: new FormArray([])
      });
    }

    // this.onChangeTickets(1)
    // for geting event id
    this.sub = this.activatedRoute.params.subscribe(params => {
      this.categoryId = +params['id']; // (+) converts string 'id' to a number
    });
    this.getNumberofForm(this.no_of_traveller);
    this.special_info()
    //  this.searched_flight_detail=this.flightdetails;
  }

  getNumberofForm(number) {
    for (var i = 0; i < number; i++) {
      this.myArr.push(false);
    }
    for (var i = 0; i < number; i++) {
      this.myArr1.push(false);
    }
    if (number) {
      this.flag = number
      this.onChangeTickets(number)
    }
  }

  createRzpayOrder(data) {

    //console.log("razor pay :",data);
  }

  initPay(): void {
    // alert(this.totalPrice * 100)
    this.rzp = new this.winRef.nativeWindow['Razorpay'](this.options)
    this.rzp.open()
  }

  paymentHandler(res: any, error: any) {
    this.zone.run(() => {
      if (res) {
        // 
        //console.log("res",res);
        this.successCallback(res.razorpay_payment_id)
      }
      if (error) {
        alert(error)
        this.cancelCallback(error)
        // 
        //console.log("error",error)
      }

      //   this.pocketService.capturePayment({
      //     amount: this.totalPrice,
      //     payment_id: res.razorpay_payment_id
      //   })
      //     .subscribe(res => {
      //       this.paymentResponse = res;
      //       this.changeRef.detectChanges();
      //      },
      //     error => {
      //       this.paymentResponse = error;
      //     });

      // },(error)=> {
      //   
      //console.log("test err",error);
      // }

    })
  }
  successCallback = function (payment_id) {
    var self = this;
    self.transcationID = payment_id;
    // alert('payment_id: ' + payment_id);
    var sendRequestData = {
      flight_booking_id: this.booking_id,
      transaction_id: payment_id,
      reference_id: this.reference_id,
      shared_inventory_id: this.shared_inventory_id
    }

    //console.log("reference_id --------->>>>>",sendRequestData)

    this.httpClient.loadingShow = true;
    self.httpClient.postRequest('v1/flight_booking/update_transaction_id', sendRequestData).subscribe((res: any) => {
      self.httpClient.loadingShow = false;
      if (res.replyCode == "success") {
        var bookingdata = {
          booking_id: this.booking_id,
          transaction_id: payment_id,
          reference_id: this.reference_id,
          shared_inventory_id: this.shared_inventory_id
        }
        sessionStorage.setItem("booking_data_agency", JSON.stringify(bookingdata))
        // alert()
        // document.getElementById("openModalButton").click();            
        self.submitted = false;
        // self.TicketbookForm.reset();
        self.bookTicketForm.reset();
        //            self.location.back();
        self.myArr = []
        self.myArr1 = []
        sessionStorage.removeItem("search_form");
        sessionStorage.removeItem("imagepath");
        sessionStorage.removeItem("flights");
        sessionStorage.removeItem("searchedflights_detail");
        sessionStorage.removeItem("form_data");
        localStorage.removeItem("inventory_flight_id");
        localStorage.removeItem("inventory_d_date");
        localStorage.removeItem("traveller_by_inventory");
        localStorage.removeItem("inventory_data");
        self.router.navigateByUrl("/home/success");
      }
      else {
        if (res.replyCode == "error")
          sessionStorage.removeItem("search_form");
        sessionStorage.removeItem("imagepath");
        sessionStorage.removeItem("flights");
        sessionStorage.removeItem("searchedflights_detail");
        sessionStorage.removeItem("form_data");
        localStorage.removeItem("inventory_flight_id");
        localStorage.removeItem("inventory_d_date");
        localStorage.removeItem("traveller_by_inventory");
        localStorage.removeItem("inventory_data");
        //  self.httpClient.showError(res.replyMsg);
        self.bookTicketForm.reset();
        // self.location.back();
        self.myArr = []
        self.myArr1 = []
        self.toastr.errorToastr(res.replyMsg);
      }

    }
      , error => {
        sessionStorage.removeItem("search_form");
        sessionStorage.removeItem("imagepath");
        sessionStorage.removeItem("flights");
        sessionStorage.removeItem("searchedflights_detail");
        sessionStorage.removeItem("form_data");
        localStorage.removeItem("inventory_flight_id");
        localStorage.removeItem("inventory_d_date");
        localStorage.removeItem("traveller_by_inventory");
        localStorage.removeItem("inventory_data");
        self.myArr = []
        self.myArr1 = []
        self.bookTicketForm.reset();
      });

  };

  cancelCallback = function (error) {
    alert(error.description + ' (Error ' + error.code + ')');
  };

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

}
